import { NEW_HOST_URL } from "../../config/envConfig";
import { fetch } from "../../utils";

export const getWorkspaceConfig = async (workspaceId) => {
  return fetch(`${NEW_HOST_URL}/workspace-config/${workspaceId}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((err) => {
      throw err;
    });
};
